// Rug Plotのレンダラー実装

import { GraphRenderer, RugPlotConfig, GraphCallbacks } from '../../../../types/graph-builder.types';
import { DataSet } from '../../../../types';
import { RugPlot } from '../../RugPlot';
import { getColumnData, getColumnById } from '../../../utils/column-utils';
import logger from '../../../utils/logger';

export const rugPlotRenderer: GraphRenderer<RugPlotConfig> = {
  validate(config: RugPlotConfig, dataset: DataSet): string | null {
    // データセットの検証
    if (!dataset || !dataset.schema || !dataset.schema.columns) {
      return 'Invalid dataset';
    }

    // 列の存在確認
    const column = getColumnById(dataset, config.column);
    if (!column) {
      return `Column "${config.column}" not found in dataset`;
    }

    // datetime型チェック
    if (column.type !== 'datetime') {
      return `Column "${column.name}" must be datetime type (found: ${column.type})`;
    }

    return null;
  },

  render(config: RugPlotConfig, dataset: DataSet, callbacks: GraphCallbacks) {
    const columnData = getColumnData(dataset, config.column);
    const column = getColumnById(dataset, config.column);

    logger.info('[RugPlotRenderer] Rendering', {
      datasetType: dataset.type,
      datasetName: dataset.name,
      datasetRowCount: dataset.rowCount,
      columnDataLength: columnData?.length
    });

    if (!columnData || !column) {
      return <div>Error: Column data not found</div>;
    }

    // datetime型のデータはISO文字列として保存されている
    // これをDateオブジェクトに変換する
    const dateData = columnData
      .map((value, index) => {
        // ISO文字列をDateオブジェクトに変換
        if (value && typeof value === 'string') {
          const date = new Date(value);
          if (!isNaN(date.getTime())) {
            return { value: date, index };
          }
        }
        return null;
      })
      .filter((item): item is { value: Date; index: number } => item !== null);

    const dates = dateData.map(item => item.value);

    logger.info('[RugPlotRenderer] Data converted', {
      totalRows: columnData.length,
      validDates: dates.length
    });

    if (dates.length === 0) {
      return <div>No valid datetime data found</div>;
    }

    // onElementSelectをonTickClickに適合させる（isAdditiveをoptionalにする）
    const handleTickClick = callbacks.onElementSelect
      ? (dataIndices: number[], isAdditive?: boolean) => {
          callbacks.onElementSelect!(dataIndices, isAdditive ?? false);
        }
      : undefined;

    return (
      <div style={{ width: '100%', height: '100%' }}>
        <RugPlot
          data={dates}
          width={undefined}
          height={undefined}
          showDensity={config.showIntensity ?? true}
          originalData={dateData}
          selectedIndices={callbacks.selectedRows}
          onTickClick={handleTickClick}
        />
      </div>
    );
  }
};
